import React from "react";
import Modal from "react-bootstrap/Modal";
import "./styles.css";

const ModalImportLog = ({ showModal, setShow, handlerAccept }) => {

    const handleClose = () => {
        setShow(false);
    };

    const errores = [
        { row: 52, column: "B", errorType: "Valor inválido", expectedValue: "Texto" },
        { row: 53, column: "D", errorType: "Requerido", expectedValue: "Número" },
        { row: 60, column: "K", errorType: "Fuera de rango", expectedValue: "0 - 100" },
    ];

    return (
        <section>
            <Modal
                className="cardAddImport"
                size="lg"
                show={showModal}
                onHide={handleClose}
                backdrop="static"
                centered
            >
                <div className="custom-card">

                    {/* HEADER */}
                    <div className="custom-card-header px-3 d-flex">
                        <h4 className="py-3">LOG DE LA IMPORTACIÓN</h4>
                    </div>

                    {/* BODY */}
                    <div className="custom-card-body px-4">

                        <div className="table-container mt-3">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Fila</th>
                                        <th>Columna</th>
                                        <th>Tipo de error</th>
                                        <th>Valor esperado</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {errores.length > 0 ? (
                                        errores.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.row}</td>
                                                <td>{item.column}</td>
                                                <td>{item.errorType}</td>
                                                <td>{item.expectedValue}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No hay errores para mostrar
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* BUTTONS */}
                        <div className="container d-flex justify-content-end mt-5">
                            <button className="btn btn-white" onClick={handleClose}>
                                Cancelar
                            </button>

                            <button
                                className="btn btn-primary ml-3"
                                onClick={handlerAccept}
                            >
                                Importar
                            </button>
                        </div>
                    </div>

                </div>
            </Modal>
        </section>
    );
};

export default ModalImportLog;
